export default "__VITE_ASSET__BCL0XywV__"